import camelCaseKeys from "camelcase-keys"

export const toCamelCase = (val: any) => {
  return camelCaseKeys(val, {
    deep: true,
    exclude: [
      // regexp exclude when key is all capital letters
      /^[A-Z0-9_]+$/,
    ],
  })
}
